import styled from 'styled-components'
import { theme } from '@provi/provi-components'

export const OptionsList = styled.div`
  display: flex;
  margin-top: ${theme.variables.spacer * 4}px;
  text-align: center;

  ${theme.breakpoints.down('md')} {
    grid-template-columns: 1fr 1fr;
    grid-gap: 10px;
    display: grid;
  }
`

export const Option = styled.div`
  cursor: pointer;
  box-sizing: border-box;
  padding: 10px;
  height: ${theme.variables.spacer * 13.5}px;
  width: ${theme.variables.spacer * 16}px;
  box-shadow: 2px 1px 15px -9px rgba(0, 0, 0, 0.5);
  margin-left: ${theme.variables.spacer}px;
  display: flex;
  justify-content: center;
  align-items: center;
  text-align: center;
  flex-direction: column;
  border-radius: 20px;
  background-color: ${({ isSelected }) => (isSelected ? theme.colors.blue900 : theme.colors.white100)};

  ${theme.breakpoints.down('md')} {
    width: 100%;
    margin: 0;
  }
`

export const OptionText = styled.p`
  font-family: CenturyGothicBold, sans-serif;
  font-size: ${({ size }) => (size ? size : 16)}px;
  margin: 0;
  color: ${({ isSelected }) => (isSelected ? theme.colors.white100 : theme.colors.blue900)};
`

export const ContainerOption = styled.div``

export const Text = styled.div`
  font-family: ${props => (props.bold ? 'CenturyGothicBold' : 'CenturyGothic')}, sans-serif;
  font-size: 16px;
  margin: 20px 0;
  color: ${theme.colors.blue900};
  ${theme.breakpoints.down('md')} {
    font-size: 12px;
  }
`
